<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(unitPrice)="data">
        {{ formatAmount(data.item.unitPrice) }}
      </template>

      <template v-slot:cell(subtotal)="data">
        {{ formatNumber(data.item.subtotal) }}
      </template>

      <template v-slot:cell(payableAmount)="data">
        {{ formatAmount(data.item.payableAmount) }}
      </template>

      <template v-slot:cell(settlementAmount)="data">
        {{ formatAmount(data.item.settlementAmount) }}
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "ApmsRegContractSettlementSummaryDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '55px'},
        {key: 'feeItemName', label: '费项名称', width: '160px'},
        {key: 'unitPrice', label: '单价（元）', width: '120px'},
        {key: 'priceUnit', label: '单位', width: '90px'},
        {key: 'subtotal', label: '工作量小计', width: '130px'},
        {key: 'payableAmount', label: '应付金额（元）', width: '140px'},
        {key: 'settlementAmount', label: '本次结算金额（元）', width: '160px'},
      ],
      items: [],
    }
  },
  created() {
    const data = this.$route.query.data
    if (data) {
      this.items = JSON.parse(data)
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    formatAmount(value) {
      const num = Number(value)
      if (isNaN(num)) {
        return '0.00'
      }
      return num.toFixed(2)
    },
    formatNumber(value) {
      const num = Number(value)
      if (isNaN(num)) return '0.0'
      return num.toFixed(1)
    },
  }
}
</script>

<style scoped>
</style>
